import Alert, { AlertProps } from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import * as React from "react";

export default function CustomActionAlerts({
  alert,
  onCLose,
  severity = "success",
  message,
}: CustomActionAlertsProps) {
  return (
    <Box sx={{ width: "100%" }}>
      <Collapse in={alert}>
        <Alert severity={severity} onClose={onCLose}>
          {message}
        </Alert>
      </Collapse>
    </Box>
  );
}

interface CustomActionAlertsProps extends AlertProps {
  alert: boolean;
  onCLose?: () => void;
  message: string | React.ReactNode;
}
